import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
declare var Fancybox: any;

@Component({
  selector: 'app-fancy-box',
  templateUrl: './fancy-box.component.html',
  styleUrls: ['./fancy-box.component.scss']
})
export class FancyBoxComponent implements OnInit, AfterViewInit {

  @Input() items: any = null;

  constructor() { }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    Fancybox.bind('[data-fancybox="gallery"]', {
      buttons: [
        "slideShow",
        "thumbs",
        "close"
      ],
      arrows: true,       
      protect: true,     
      animationEffect: "zoom",  
      transitionEffect: "slide",  
    });
  }

  transfromImageUrl(imgUrl: any) : any {
    return imgUrl.replace("mobile_photoslide", "photo_600x380");
  }

}
